import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import styles from "./styles.module.css";
import { Box, Button, DialogActions, DialogContent, Grid } from "@mui/material";
import GenericTextField from "../../components/GenericTextField";

const CodFornecedorFormSchema = z
  .object({
    id_conciliacao_filtro_codigo_fornecedor: z.number().readonly(),
    codigo_cliente_fornecedor: z.string(),
    cliente_fornecedor: z.string(),
    filtro: z.string()
  })
  .partial({
    id_conciliacao_filtro_codigo_fornecedor: true
  })
  .required({
    codigo_cliente_fornecedor: true,
    cliente_fornecedor: true,
    filtro: true
  });

type CodFornecedorFormData = z.infer<typeof CodFornecedorFormSchema>;

type CodFornecedorFormProps = {
  codFornecedorValues: CodFornecedorFormData;
  onSubmit(data: CodFornecedorFormData): void;
  onClose(event: any): void;
};

export default function CodFornecedorForm({
  codFornecedorValues,
  onSubmit,
  onClose,
}: CodFornecedorFormProps) {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<CodFornecedorFormData>({
    mode: "onChange",
    resolver: zodResolver(CodFornecedorFormSchema),
    defaultValues: {
      id_conciliacao_filtro_codigo_fornecedor:
        codFornecedorValues.id_conciliacao_filtro_codigo_fornecedor || undefined,
      codigo_cliente_fornecedor: codFornecedorValues.codigo_cliente_fornecedor,
      cliente_fornecedor: codFornecedorValues.cliente_fornecedor,
      filtro: codFornecedorValues.filtro
    },
  });

  const handleCloseForm = (event: any) => {
    onClose(event);
  };

  const submit = (data: CodFornecedorFormData) => {
    const body: any = {
      filtroCodigoFornecedor: {
        id_conciliacao_filtro_codigo_fornecedor: data.id_conciliacao_filtro_codigo_fornecedor,
        codigoClienteFornecedor: data.codigo_cliente_fornecedor,
        clienteFornecedor: data.cliente_fornecedor,
        filtro: data.filtro,
      },
    };

    onSubmit(body);
  };

  return (
    <form onSubmit={handleSubmit(submit)} className={styles.formDiv}>
      <DialogContent className={styles.formContainer}>
        <Box className={styles.formContent}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Controller
                name="id_conciliacao_filtro_codigo_fornecedor"
                control={control}
                defaultValue={codFornecedorValues.id_conciliacao_filtro_codigo_fornecedor}
                render={({ field: { ref, ...field } }) => (
                  <GenericTextField
                    disabled
                    label="ID"
                    error={Boolean(errors.id_conciliacao_filtro_codigo_fornecedor)}
                    helperText={errors.id_conciliacao_filtro_codigo_fornecedor?.message}
                    placeholder={"Novo Código"}
                    inputRef={ref}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="filtro"
                control={control}
                defaultValue={codFornecedorValues.filtro}
                render={({ field: { ref, ...field } }) => (
                  <GenericTextField
                    label="Filtro"
                    error={Boolean(errors.filtro)}
                    helperText={errors.filtro?.message}
                    placeholder={"Novo Filtro"}
                    inputRef={ref}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="codigo_cliente_fornecedor"
                control={control}
                defaultValue={codFornecedorValues.codigo_cliente_fornecedor}
                render={({ field: { ref, ...field } }) => (
                  <GenericTextField
                    label="Cód. Cliente Fornecedor"
                    error={Boolean(errors.codigo_cliente_fornecedor)}
                    helperText={errors.codigo_cliente_fornecedor?.message}
                    placeholder={"Cód. Cliente Fornecedor"}
                    inputRef={ref}
                    {...field}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Controller
                name="cliente_fornecedor"
                control={control}
                defaultValue={codFornecedorValues.cliente_fornecedor}
                render={({ field: { ref, ...field } }) => (
                  <GenericTextField
                    label="Cliente Fornecedor"
                    error={Boolean(errors.cliente_fornecedor)}
                    helperText={errors.cliente_fornecedor?.message}
                    placeholder={"Cliente Fornecedor"}
                    inputRef={ref}
                    {...field}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Box>
        <Box>
          <DialogActions className={styles.botoesPopupGeral}>
            <Button
              className={styles.botaoPopupCancelar}
              onClick={handleCloseForm}
              size="small"
            >
              Cancelar
            </Button>
            <Button
              className={styles.botaoPopupSalvar}
              type="submit"
              color="primary"
              size="small"
            >
              Salvar
            </Button>
          </DialogActions>
        </Box>
      </DialogContent>
    </form>
  );
}
